import { render } from "./ProductSelect.vue?vue&type=template&id=0d241f77&scoped=true&ts=true"
import script from "./ProductSelect.vue?vue&type=script&lang=ts"
export * from "./ProductSelect.vue?vue&type=script&lang=ts"

import "./ProductSelect.vue?vue&type=style&index=0&id=0d241f77&lang=scss"
import "./ProductSelect.vue?vue&type=style&index=1&id=0d241f77&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d241f77"]])

export default __exports__